import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import { URL } from "../../Redux/common/url";
import { URL } from "../Redux/common/url";

function Slider() {
  // 👉 Admin se Redux ke through data lena
  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state?.allapi?.slider_list : {}
  );

  // 👉 Slider images (admin panel wali)
  const images = slider_list?.sliders
    ? slider_list?.sliders.map((item) => URL?.API_BASE_URL + item?.image)
    : [];

  const [currentIndex, setCurrentIndex] = useState(0);

  // 👉 Auto slide every 4 sec
  useEffect(() => {
    if (!images.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images]);

  // 👉 Admin se data nahi aaya → slider empty
  if (!images.length) {
    return null;
  }

  return (
    <>
      {/* Inline CSS */}
      <style>
        {`
          .ritu-slider-home {
            width: 100%;
            position: relative;
            top:5px;
          }

          .ritu-slider-container {
            position: relative;
            width: 100%;
            height: 130px;   /* 👈 Height yaha change karna */
            overflow: hidden;
            padding-top: 0px;
          }

          .ritu-slider-background {
            position: absolute;
            inset: 0;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            transition: background-image 0.8s ease-in-out;
            display: flex;
            align-items: center;
          }

          @media (min-width: 400px) {
            .ritu-slider-container {
              height: 130px;
            }
          }
          @media (min-width: 430px) {
            .ritu-slider-container {
              height: 140px;
            }
          }
          @media (min-width: 460px) {
            .ritu-slider-container {
              height: 160px;
            }
          }
          
          @media (min-width: 500px) {
            .ritu-slider-container {
              height:175px;
            }
          }
          @media (min-width: 550px) {
            .ritu-slider-container {
              height: 195px;
            }
          }
          @media (min-width: 600px) {
            .ritu-slider-container {
              height: 220px;
            }
          }
          @media (min-width: 650px) {
            .ritu-slider-container {
              height: 255px;
            }
          }
          @media (min-width: 700px) {
            .ritu-slider-container {
              height: 275px;
            }
          }
          @media (min-width: 750px) {
            .ritu-slider-container {
              height: 295px;
            }
          }
          @media (min-width: 800px) {
            .ritu-slider-container {
              height: 315px;
            }
          }
          @media (min-width: 850px) {
            .ritu-slider-container {
              height: 335px;
            }
          }
          @media (min-width: 900px) {
            .ritu-slider-container {
              height: 355px;
            }
          }
          @media (min-width: 950px) {
            .ritu-slider-container {
              height: 370px;
            }
          }

          @media (min-width: 1000px) {
            .ritu-slider-container {
              height: 400px;
            }
          }
         
        `}
      </style>

      <div className="ritu-slider-home">
        <div className="ritu-slider-container">
          <div
            className="ritu-slider-background"
            style={{
              backgroundImage: `url(${images[currentIndex]})`,
            }}
          ></div>
        </div>
      </div>
    </>
  );
}

export default Slider;
